import {Component, Input} from '@angular/core';
import {RouterLink} from '@angular/router';
import {NgTemplateOutlet, NgClass} from '@angular/common';

@Component({
  selector: 'app-link',
  standalone: true,
  imports: [
    RouterLink,
    NgTemplateOutlet,
    NgClass
  ],
  templateUrl: './link.component.html',
  styleUrl: './link.component.scss'
})
export class LinkComponent {

  @Input() public href: string = '';
  @Input() public target: string = '_self';
  @Input() public style: string = '';
  @Input() public title: string = '';
  @Input() public active: boolean = false;
  @Input() public noPadding: boolean = false;

  /**
   * Centralized class builder → avoids duplication in template
   */
  public get classes(): string[] {
    return [
      this.style === 'nav' ? 'nav-link' :
      this.style === 'dropdown' ? 'dropdown-item' :
      this.style === 'alert' ? 'alert-link' :
      this.style === 'pager' ? 'page-link' : '',
      this.active ? 'active' : '',
      this.noPadding ? 'p-0' : ''
    ].filter(Boolean);
  }

  public onClick(): boolean {
    return false;
  }
}